import { render, staticRenderFns } from "./SwitchCheck.vue?vue&type=template&id=3134a256"
import script from "./SwitchCheck.vue?vue&type=script&lang=ts"
export * from "./SwitchCheck.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports